module.exports = __webpack_public_path__ + "img/inazuma.83c51365.jpeg";